export const DefaultPageSize = 10;
export const SearchSWRKey = "search-page-elasticsearch";
